var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgepicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.0833V1.91667C11.25 1.275 10.725 0.75 10.0833 0.75H1.91667C1.275 0.75 0.75 1.275 0.75 1.91667V10.0833C0.75 10.725 1.275 11.25 1.91667 11.25H10.0833C10.725 11.25 11.25 10.725 11.25 10.0833ZM4.19167 7.155L5.41667 8.63083L7.225 6.30333C7.34167 6.15167 7.575 6.15167 7.69167 6.30917L9.73917 9.03917C9.885 9.23167 9.745 9.50583 9.50583 9.50583H2.51167C2.26667 9.50583 2.1325 9.22583 2.28417 9.03333L3.73667 7.16667C3.8475 7.015 4.06917 7.00917 4.19167 7.155Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgepicture);
export default __webpack_public_path__ + "static/media/badge.picture.4f2ae4f89cf2805abf8f405b2217b002.svg";
export { ForwardRef as ReactComponent };